"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function () {}; return { s: F, n: function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function (e) { throw e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function () { it = it.call(o); }, n: function () { var step = it.next(); normalCompletion = step.done; return step; }, e: function (e) { didErr = true; err = e; }, f: function () { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        let key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: () => from[key],
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = mod => __copyProps(__defProp({}, "__esModule", {
  value: true
}), mod);
var extension_exports = {};
__export(extension_exports, {
  WebSocketWrapper: () => WebSocketWrapper
});
module.exports = __toCommonJS(extension_exports);
var import_request = require("../utils/request");
class WebSocketWrapper {
  constructor() {
    this.handleSocketOpen = () => {
      var _this$connectResolve;
      (_this$connectResolve = this.connectResolve) === null || _this$connectResolve === void 0 ? void 0 : _this$connectResolve.call(this);
    };
    this.handleSocketError = event => {
      var _this$onError;
      (_this$onError = this.onError) === null || _this$onError === void 0 ? void 0 : _this$onError.call(this, event.error);
    };
    this.handleSocketClose = () => {
      var _this$onDisconnect, _this$disconnectResol;
      if (this.socket) {
        this.socket.removeEventListener("open", this.handleSocketOpen);
        this.socket.removeEventListener("error", this.handleSocketError);
        this.socket.removeEventListener("close", this.handleSocketClose);
        this.socket.removeEventListener("message", this.handleSocketMessage);
      }
      (_this$onDisconnect = this.onDisconnect) === null || _this$onDisconnect === void 0 ? void 0 : _this$onDisconnect.call(this);
      (_this$disconnectResol = this.disconnectResolve) === null || _this$disconnectResol === void 0 ? void 0 : _this$disconnectResol.call(this);
    };
    this.handleSocketMessage = event => {
      var _this$onMessage;
      (_this$onMessage = this.onMessage) === null || _this$onMessage === void 0 ? void 0 : _this$onMessage.call(this, JSON.parse(event.data));
    };
    if (typeof chrome.runtime === "undefined") throw new Error("chrome is undefined - are you running in a background script?");
  }
  async connect(runtimeURL, authToken, appId) {
    const url = (0, import_request.addQueryParamsToUrl)(runtimeURL, {
      jwt: authToken,
      [import_request.SM_SDK_PARAM_NAME]: (0, import_request.getSmSDKVersion)(),
      [import_request.SM_APP_PARAM_NAME]: appId
    });
    try {
      this.socket = new WebSocket(url);
    } catch (error) {
      var _this$connectReject;
      (_this$connectReject = this.connectReject) === null || _this$connectReject === void 0 ? void 0 : _this$connectReject.call(this, error);
      return Promise.reject(error);
    }
    this.socket.binaryType = "arraybuffer";
    this.socket.addEventListener("open", this.handleSocketOpen);
    this.socket.addEventListener("error", this.handleSocketError);
    this.socket.addEventListener("close", this.handleSocketClose);
    this.socket.addEventListener("message", this.handleSocketMessage);
    return new Promise((resolve, reject) => {
      this.connectResolve = resolve;
      this.connectReject = reject;
    });
  }
  async disconnect() {
    if (this.socket && this.isOpen()) this.socket.close();else return;
    return new Promise(resolve => {
      this.disconnectResolve = resolve;
    });
  }
  sendAudioBuffer(buffer) {
    if (this.socket && this.isOpen()) {
      this.socket.send(buffer);
    } else console.error("Tried to send audio when socket was closed");
  }
  sendMessage(message) {
    if (this.socket && this.isOpen()) {
      this.socket.send(message);
    } else console.error("Tried to send message when socket was closed", message);
  }
  isOpen() {
    var _this$socket;
    return ((_this$socket = this.socket) === null || _this$socket === void 0 ? void 0 : _this$socket.readyState) === WebSocket.OPEN;
  }
}